import userExperience from "./userExperience";
import productThinking from "./productThinking";
import research from "./research";
import userInterface from "./userInterface";
import communication from "./communication";

export default {
  ...productThinking,
  ...userExperience,
  ...research,
  ...userInterface,
  ...communication,
};
